import { Box } from '@mui/material';
import DayPicker from 'react-day-picker';
import styled from 'styled-components';

export const DatePickerContent = styled(Box)`
border-top: 1px solid ${props => props.theme.palette.grey[300]};  
width: 100%;

 ${props => props.theme.breakpoints.only('sm')} {
    border-top: 1px solid transparent;  
  }

& .DayPicker {
  width: 100%;
}
`;

export const StyledDayPicker = styled(DayPicker)`

  .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside):not(.DayPicker-Day--disabled) {
    background-color: ${props => props.theme.palette.secondary.light};
    color: #fff;    
  }

  .DayPicker-Day {
    padding: 0.5em;
    font-size: 0.95em;
    border-radius: 0 !important;
    width: ${props => props.theme.spacing(5.5)};
    height: ${props => props.theme.spacing(5.5)};
    font-weight: 500;
    

    ${props => props.theme.breakpoints.only('md')} {
      height: ${props => props.theme.spacing(5)};
    }
  }

  .DayPicker-Day--disabled {

    & > div > div:last-child {      
      color: transparent;        

      &:before {
        content: "-"; 
        color: #dce0e0;
        position: absolute;
        transform: translateX(${props => props.theme.spacing(1.5)});
      }
    }
  }

  .DayPicker-Day--start:not(.DayPicker-Day--outside) {
    border-top-left-radius: 50% !important;
    border-bottom-left-radius: 50% !important;
    background-color: ${props => props.theme.palette.secondary.dark} !important;
  }
  .DayPicker-Day--end:not(.DayPicker-Day--outside):not(.DayPicker-Day--disabled) {
    border-top-right-radius: 50% !important;
    border-bottom-right-radius: 50% !important;
    background-color: ${props => props.theme.palette.secondary.dark} !important;
  }
  .DayPicker-Day--today:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside):not(.DayPicker-Day--disabled) {
    background-color: ${props => props.theme.palette.secondary.dark} !important;
  }

  .DayPicker-Day--minNight {
    color: ${props => props.theme.palette.grey[200]};
  }

  .DayPicker-Caption {    
    border-bottom: 1px dashed ${props => props.theme.palette.grey[500]};    
    padding-bottom: ${props => props.theme.spacing(1)};

    
    ${props => props.theme.breakpoints.down('sm')} {
      border-top: 1px dashed ${props => props.theme.palette.grey[500]};    
    padding-top: ${props => props.theme.spacing(1)};
    }
  }

  .DayPicker-wrapper {
    min-height: 392px;
    padding-bottom: ${props => props.theme.spacing(1)};
    justify-content: center;

    ${props => props.theme.breakpoints.only('md')} {
      min-height: 380px;
    }

    ${props => props.theme.breakpoints.only('sm')} {
      min-height: 450px;
  }
  }

  .DayPicker-Months { 
      margin-top: ${props => props.theme.spacing(1)};
      margin-bottom: ${props => props.theme.spacing(1)};      

      & .DayPicker-Month * {        
        animation: SimpleFadeIn 0.2s ease;  

          @keyframes SimpleFadeIn {
            0% {
              opacity: 0;    
            }
            100% {
              opacity: 1;    
            }
          }
        }

      ${props => props.theme.breakpoints.up('xs')} {
      & .DayPicker-Month {
        max-width: 360px;
      }
    }
    
    ${props => props.theme.breakpoints.only('md')} {
      margin-top: 0px;
      margin-bottom: 0px;

      & .DayPicker-Month {
        margin-top:${props => props.theme.spacing(1.5)};
      }
    }

    ${props => props.theme.breakpoints.down('sm')} {
      & .DayPicker-Month {
        width: 100%;
      }
    }

    .DayPicker-Weekday {      
      color: ${props => props.theme.palette.primary.main};
      font-weight: 500;
    }
  }

  .DayPicker-NavBar {
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 1em;
  }

  .DayPicker-NavButton {
    color: ${props => props.theme.palette.grey[700]};
    position: unset;
    width: ${props => props.theme.spacing(3)};
  }

  .DayPicker-NavButton--prev::after {
    content: 'Back';
    margin-left: 24px;
  }

  .DayPicker-NavButton--next::before {
    content: 'Next';
    margin-left: -32px;
  }

  .DayPicker-NavButton--interactionDisabled {
    display: block;
    visibility: hidden;
  }
`;
